import {
  FunnelStepHeader,
  FunnelWithHelper,
  StepperFooter,
  useStepperContext,
} from '@folio/components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ComplianceModule } from '../ComplianceModule/ComplianceModule';
import { Stack } from '@folio/components/ui/flex';

type ComplianceFunnelModuleProps = {
  title?: string;
  subtitle?: string;
  helper?: React.ReactNode;
};

export function ComplianceFunnelModule({
  title,
  subtitle,
  helper,
}: ComplianceFunnelModuleProps = {}) {
  const { t } = useTranslation();
  const stepper = useStepperContext();
  const [canGoNext, setCanGoNext] = useState(false);

  return (
    <Stack gap={6}>
      <FunnelStepHeader
        title={title ?? t('funnelSteps.compliance.title')}
        subtitle={subtitle ?? t('funnelSteps.compliance.subtitle', '')}
      />
      <FunnelWithHelper helper={helper}>
        <ComplianceModule onUpdate={setCanGoNext} />
      </FunnelWithHelper>
      <StepperFooter nextButtonEnabled={canGoNext} onNext={() => stepper.next()} />
    </Stack>
  );
}
